<template>

  <div class="hello">


	<h1 style="margin-top:1em;margin-bottom:1em;font-size:230%">Apprenez de la géographie, du vocabulaire, etc.</h1>
	<p>
		Cette application de mémorisation vous permet de créer vos propres listes de mots à mémoriser, et de générer des quizz automatiquement.
	</p>
	<p>
		Vous pouvez également utiliser les listes publiques créées par d'autres utilisateurs, voici quelques exemples :
	</p>

	<br/>
	<div class="list-group">
						<a href="/l-15" class="list-group-item">Breton : Famille</a>
						<a href="/l-16" class="list-group-item">Breton : Pluriels</a>
					<a href="/login" class="list-group-item list-group-item-warning" style="margin-top:2em">Plus de listes</a>
	</div>

	<hr style="margin:5em"/>

    <h1>{{ msg }}</h1>
    <h2>Essential Linksss</h2>
    <ul>
      <li><a href="https://vuejs.org" target="_blank" rel="noopener">Core Docs</a></li>
      <li><a href="https://forum.vuejs.org" target="_blank" rel="noopener">Forum</a></li>
      <li><a href="http://chat.vuejs.org/" target="_blank" rel="noopener">Vue Community Chat</a></li>
      <li><a href="https://twitter.com/vuejs" target="_blank" rel="noopener">Twitter</a></li>
      <li><a href="http://vuejs-templates.github.io/webpack/" target="_blank" rel="noopener">Docs for This Template</a></li>
    </ul>
    <h2>Ecosystem</h2>
    <ul>
      <li><a href="http://router.vuejs.org/" target="_blank" rel="noopener">vue-router</a></li>
      <li><a href="http://vuex.vuejs.org/" target="_blank" rel="noopener">vuex</a></li>
      <li><a href="http://vue-loader.vuejs.org/" target="_blank" rel="noopener">vue-loader</a></li>
      <li><a href="https://github.com/vuejs/awesome-vue" target="_blank" rel="noopener">awesome-vue</a></li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'hello',
  data () {
    return {
      msg: 'Welcome to Your Vue.js PWA'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
h1, h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #35495E;
}
</style>



// WEBPACK FOOTER //
// src/components/Home.vue